// @flow

import * as React from 'react';

import { Select } from '@gandi/form';

import { useAppSelector } from 'src/hooks/useAppSelector';

import {
  selectLocaleOptions,
  type Option,
} from '../../../modules/app/selectors/locale';

type Props = {
  onChange: (selectedOption: Option) => void,
  disabled: boolean,
  value: string,
  name: string,
};

export default function LocaleSelect({
  onChange,
  disabled,
  value,
  name,
}: Props): React.MixedElement {
  const options = useAppSelector(selectLocaleOptions);

  const onSelectChange = (evt: SyntheticEvent<HTMLSelectElement>): void => {
    const newLocale = options.find(
      opt => opt.value === evt.currentTarget.value,
    );

    if (newLocale) {
      onChange(newLocale);
    }
  };

  return (
    <Select
      name={name}
      // $FlowFixMe[incompatible-type] - Option is the same as GandiFormSelectOption<string>
      // $FlowFixMe[incompatible-indexer]
      values={options}
      value={value}
      onChange={onSelectChange}
      disabled={disabled}
    />
  );
}
